import { Component, Input } from '@angular/core';
import { OriginalFileNameModel } from '../../../types/file-signature';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-file-list',
  imports: [CommonModule],
  templateUrl: './file-list.component.html',
  styleUrl: './file-list.component.scss'
})
export class FileListComponent {
  @Input() originFileNameList: OriginalFileNameModel[] = [];
}
